import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const CHECK_TIN_REQUEST = 'CHECK_TIN_REQUEST';
export const CHECK_TIN_SUCCESS = 'CHECK_TIN_SUCCESS';
export const CHECK_TIN_FAILURE = 'CHECK_TIN_FAILURE';

function checkTinRequest() {
  return {
    type: CHECK_TIN_REQUEST,
    isCheckingTin: true
  };
}

function checkTinSuccess(data) {
  return {
    type: CHECK_TIN_SUCCESS,
    tinMatchResult: data,
    isCheckingTin: false
  };
}

function checkTinFailure() {
  return {
    type: CHECK_TIN_FAILURE,
    isCheckingTin: false
  };
}

export function checkTin(formId, updateExisting) {
  return (dispatch) => {
    dispatch(checkTinRequest());
    const promise = () => ApiService
      .checkTin(formId, updateExisting)
      .then((response) => {
        dispatch(checkTinSuccess(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, checkTinFailure, true));
        }
      });
    return promise();
  };
}
